import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaUser, FaEnvelope, FaLock, FaPhoneAlt } from "react-icons/fa";
import Navbar from "./Navbar";
import Fotter from "./Fotter";

const DoctorSignup = () => {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    email: "",
    mobileNumber: "",
  });

  const [responseMessage, setResponseMessage] = useState("");
  const [showSidebar, setShowSidebar] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requestBody = {
      username: formData.username,
      password: formData.password,
      enabled: true,
      email: formData.email,
      mobileNumber: formData.mobileNumber,
    };

    try {
      const response = await fetch("https://69.62.72.147:8090/api/docregister", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const message = await response.text();
      setResponseMessage(message);
      setShowSidebar(true);

      if (response.ok) {
        setFormData({
          username: "",
          password: "",
          email: "",
          mobileNumber: "",
        });
      }
    } catch (error) {
      setResponseMessage("An unexpected error occurred.");
      setShowSidebar(true);
    }
  };

  const fields = [
    { name: "username", type: "text", placeholder: "Username", icon: <FaUser /> },
    { name: "email", type: "email", placeholder: "Email", icon: <FaEnvelope /> },
    { name: "mobileNumber", type: "text", placeholder: "Mobile Number", icon: <FaPhoneAlt /> },
    { name: "password", type: "password", placeholder: "Password", icon: <FaLock /> },
  ];

  return (
    <>
      <Navbar />
      <div style={styles.container}>
        <motion.div
          style={styles.card}
          initial={{ scale: 0.9, y: -100, opacity: 0 }}
          animate={{ scale: 1, y: 0, opacity: 1 }}
          transition={{ duration: 0.8, type: "spring" }}
          whileHover={{ rotateX: 5, rotateY: 5, boxShadow: "0 25px 50px rgba(0,0,0,0.2)" }}
        >
          <h2 style={styles.heading}>Doctor Signup</h2>

          <form onSubmit={handleSubmit} style={styles.form}>
            {fields.map((field) => (
              <motion.div
                key={field.name}
                style={styles.inputContainer}
                whileFocus={{ scale: 1.05 }}
                whileHover={{ scale: 1.02 }}
              >
                <div style={styles.icon}>{field.icon}</div>
                <input
                  type={field.type}
                  name={field.name}
                  placeholder={field.placeholder}
                  value={formData[field.name]}
                  onChange={handleChange}
                  required
                  style={styles.input}
                />
              </motion.div>
            ))}

            <motion.button
              type="submit"
              style={styles.button}
              whileHover={{
                scale: 1.05,
                background: "#28a745",
                boxShadow: "0px 0px 15px rgba(40, 167, 69, 0.5)",
              }}
              whileTap={{ scale: 0.95 }}
            >
              Register Now
            </motion.button>
          </form>
        </motion.div>
      </div>

      {/* Sidebar response message */}
      <AnimatePresence>
        {showSidebar && (
          <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.4 }}
            style={styles.sidebar}
          >
            <div style={styles.sidebarContent}>
              <p>{responseMessage}</p>
              <button onClick={() => setShowSidebar(false)} style={styles.closeBtn}>
                Close
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <Fotter />
    </>
  );
};

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "100px 20px 40px",
    background: "linear-gradient(120deg, #00c6ff, #0072ff)",
  },
  card: {
    background: "rgba(255, 255, 255, 0.95)",
    padding: "40px 30px",
    borderRadius: "20px",
    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.15)",
    textAlign: "center",
    width: "100%",
    maxWidth: "480px",
    backdropFilter: "blur(12px)",
    perspective: "1000px",
    transformStyle: "preserve-3d",
  },
  heading: {
    fontSize: "30px",
    marginBottom: "25px",
    color: "#222",
    fontFamily: "'Poppins', sans-serif",
    fontWeight: "700",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "18px",
  },
  inputContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    background: "#f1f1f1",
    borderRadius: "10px",
    padding: "10px 15px",
    transition: "all 0.3s ease",
  },
  icon: {
    marginRight: "10px",
    fontSize: "18px",
    color: "#333",
  },
  input: {
    flex: 1,
    border: "none",
    outline: "none",
    background: "transparent",
    fontSize: "16px",
    fontFamily: "'Poppins', sans-serif",
  },
  button: {
    padding: "12px",
    borderRadius: "10px",
    fontSize: "16px",
    fontWeight: "bold",
    background: "#ffc107",
    border: "none",
    color: "#333",
    fontFamily: "'Poppins', sans-serif",
    cursor: "pointer",
    transition: "all 0.3s",
  },
  sidebar: {
    position: "fixed",
    top: 0,
    right: 0,
    width: "300px",
    height: "100vh",
    background: "#fff",
    boxShadow: "-3px 0 15px rgba(0,0,0,0.2)",
    zIndex: 1000,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "30px",
    flexDirection: "column",
  },
  sidebarContent: {
    textAlign: "center",
    fontFamily: "'Poppins', sans-serif",
  },
  closeBtn: {
    marginTop: "20px",
    padding: "10px 20px",
    border: "none",
    borderRadius: "8px",
    background: "#ff4757",
    color: "#fff",
    fontWeight: "bold",
    cursor: "pointer",
  },
};

export default DoctorSignup;
